import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router';
import { AccessibilityBypassBlock } from '@skillz/accessibility';
import LandscapeMessage from './layoutMobile/landscapeMessage/LandscapeMessage';
import LeftSideMenu from './leftSideMenu/LeftSideMenu';
import Header from './hedaer/Header';
import ScrollLTR from '../../shared/components/ui/scrollLTR/ScrollLTR';
import OldViewBtn from '../../shared/components/ui/oldViewBtn/OldViewBtn';
import pathRouts from '../../shared/enums/pathRoute';
import classes from './Layout.module.css';

const Layout = ({ dynamicTabs }) => {

    const { texts } = useSelector(state => state.translate);
    const scrollerRef = useRef(null);
    const location = useLocation();
    const isIframeRoute = dynamicTabs?.some(tab => tab.type === "iframe" && location.pathname.endsWith(tab.route)) || location.pathname.includes(pathRouts.BOT);
    const isManagerRoute = location.pathname.includes(pathRouts.MANAGERDASHBOARD);

    useEffect(() => {
        if (!location.hash && scrollerRef.current) {
            scrollerRef.current.scrollTop = 0;
            scrollerRef.current.scrollLeft = 0;
        }
    }, [location.pathname, location.hash]);

    return (
        <div className={classes.Layout}>
            <AccessibilityBypassBlock id="main" text={texts.skipToMainContent} />
            <Header />
            <div className={classes.ContentWrapper}>
                <div className={classes.ContentInner}>
                    <LeftSideMenu className={classes.LeftSideMenu} dynamicTabs={dynamicTabs} forceCompact={isIframeRoute || isManagerRoute} />
                    {window.config.showOldViewBtn && <OldViewBtn text={texts.oldView} className={classes.OldViewBtn} isIframeRoute={isIframeRoute || isManagerRoute} />}
                </div>

                <ScrollLTR ref={scrollerRef} dropClass={`${classes.Outlet} ${(isIframeRoute || isManagerRoute) ? classes.OutletIframe : ''}`} downDropStyle={(isIframeRoute || isManagerRoute) ? classes.IframeScrollInner : undefined} height="100%">
                    <div className={(isIframeRoute || isManagerRoute) ? classes.ContentIframe : classes.Content}>
                        <Outlet></Outlet>
                    </div>
                </ScrollLTR>
            </div>

            <LandscapeMessage></LandscapeMessage>
        </div>
    )
}

export default Layout;